import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { getDefaultRoute } from "@/lib/rbac";

/** Sends unknown protected paths to the user's default allowed page. */
export default function DefaultRedirect() {
  const { user, permissions, isLoading } = useAuth();

  if (isLoading) return null;

  return <Navigate to={getDefaultRoute(permissions, user?.role)} replace />;
}
